import React from 'react';
import {Trans} from 'react-i18next';

export default function OverLayLoader() {
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        zIndex: 1100,
        backgroundColor: 'rgba(0,0,0,.2)',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <div
        style={{
          position: 'absolute',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <div
          className="spinner-border"
          role="status"
          style={{
            width: '4rem',
            height: '4rem',
            border: '0.5em solid currentColor',
            borderRightColor: 'transparent',
            padding: '1rem',
          }}
        >
          <span className="sr-only">Loading...</span>
        </div>
        <h5>
          <Trans i18nKey="c.spinner.overlay.loader.updating">Updating...</Trans>
        </h5>
      </div>
    </div>
  );
}
